<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
import DefaultFull from '../../default/groups/Full.vue'
import ToTransTopRight from '../transitions/energetic_frequencies/ToTransTopRight.vue'

const props = defineProps({
  item: Array,
})

const endTransitionComponent = ref(null)
const { onDisappear } = useDisappearable()
onDisappear(async () => await endTransitionComponent.value.start())
</script>

<template>
  <ToTransTopRight ref="endTransitionComponent">
    <DefaultFull v-bind="props" />
  </ToTransTopRight>
</template>
